import { useTypedQuery } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { sortChecklistsByName } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

export const useDefaultChecklistsQuery = () =>
  useTypedQuery({
    queryKey: ChecklistsDashboardQueryKeys.defaultChecklists,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, {}, baseUrl)).data.checklists ?? [],
    select: sortChecklistsByName
  });
